// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { FetchContext } from 'Contexts/FetchContext';

export default function useFetch() {
  return useContext(FetchContext);
}
